<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { useUserStore } from '../stores/user';
import { storeToRefs } from 'pinia';
import BravoPasswordResetConfirm from '@services/ui-component-library/components/BravoPasswordResetConfirm.vue';
const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();
const userStore = useUserStore();

const token = route.params.token as string;
const email = decodeURIComponent(route.params.email as string);

// Reactively bound to the store so the component updates when userStatus
// populates the policy (which happens asynchronously via setTimeout in auth.ts)
const { passwordPolicy } = storeToRefs(userStore);

// Trigger userStatus if not yet initialized so password_policy is fetched
onMounted(async () => {
    if (!authStore.isInitialized) {
        await authStore.initialize();
    }
});

const handleSubmit = async (password: string) => {
    await authStore.userChangePassword({
        email,
        password,
        confirm_password: password, // Use same value for confirm_password
        token
    });

    // Redirect to login after successful password change
    setTimeout(() => {
        router.push('/login');
    }, 2000);
};

const backToLogin = () => {
    router.push('/login');
};

</script>

<template>
    <div class="forgot-password-page" data-testid="login-page">
        <div class="logo-container" data-testid="logo-container">
            <img src="../assets/ovationcxm-login-logo.png" alt="OvationCXM Logo" data-testid="logo-image" />
        </div>

        <BravoPasswordResetConfirm
            :userEmail="email"
            :submitHandler="handleSubmit"
            :passwordPolicy="passwordPolicy"
            @backToLogin="backToLogin"
        />
    </div>
</template>

<style scoped>
.forgot-password-page {
    background-image: url('../assets/login-ovationcxm-background.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

.logo-container {
    max-width: 300px;
}

.logo-container img {
    width: 100%;
    height: auto;
}

/* Override the BravoLoginScreenSSO's wrapper background */
:deep(.login-wrapper) {
    position: relative !important;
    background: transparent !important;
}
</style>
